import { useParams, Navigate } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import { useGetCampaignById } from 'features/campaigns/campaigns_api'
import { WORKFLOW_STATUS } from 'models/campaign'

const DETAIL_STATUSES: string[] = [
  WORKFLOW_STATUS.DRAFT,
  WORKFLOW_STATUS.CONTACTS_REQUESTED,
  WORKFLOW_STATUS.READY_TO_LAUNCH,
]

export function CampaignRouterPageV2() {
  // Mounted at both `campaigns/:id` (index child of CampaignRouteLayout) and
  // the legacy catch-all `campaigns/:campaign_id/:tab?` — accept either name.
  const params = useParams<{ campaign_id?: string; id?: string }>()
  const campaign_id = params.campaign_id ?? params.id
  const { data: campaign, isLoading } = useGetCampaignById(Number(campaign_id))

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spinner animation="border" />
      </div>
    )
  }

  if (!campaign) {
    return <Navigate to="/campaigns" replace />
  }

  if (DETAIL_STATUSES.includes(campaign.workflow_status as string)) {
    return <Navigate to={`/campaigns/${campaign_id}/detail`} replace />
  }

  return <Navigate to={`/campaigns/${campaign_id}/dashboard`} replace />
}
